var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-3 py-0",attrs:{"fluid":""}},[_c('v-textarea',{attrs:{"name":"input-7-1","filled":"","label":"OBS:","auto-grow":""},on:{"change":function($event){_vm.service.observations = _vm.observations}},model:{value:(_vm.observations),callback:function ($$v) {_vm.observations=$$v},expression:"observations"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }